/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Substitution_Can_RepresentInputs */

const en_forms_users_settings_substitution_can_represent = /** @type {(inputs: Forms_Users_Settings_Substitution_Can_RepresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Represent`)
};

const de_forms_users_settings_substitution_can_represent = /** @type {(inputs: Forms_Users_Settings_Substitution_Can_RepresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Represent`)
};

/**
* | output |
* | --- |
* | "Represent" |
*
* @param {Forms_Users_Settings_Substitution_Can_RepresentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_substitution_can_represent = /** @type {((inputs?: Forms_Users_Settings_Substitution_Can_RepresentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Substitution_Can_RepresentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_substitution_can_represent(inputs)
	return de_forms_users_settings_substitution_can_represent(inputs)
});